(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/slide-in-container/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/app/slide-in-container/assets/javascripts/init.js'); 
(function(svs) {
  'use strict';

  svs.app.slide_in_container.logger = svs.core.log.getLogger('component:slide_in_container');

  svs.app.slideInContainer = (function() {
    var view;

    var init = function(options) {
      if (!options.view) {
        svs.app.slide_in_container.logger.error('Slide in container component missing view in options');
      }
      options.headerOptions = options.headerOptions || {};
      options.viewOptions = options.viewOptions || {};
      options.swipeContent = options.swipeContent || false;
      options.showTabToggle = options.showTabToggle || false;

      if (svs.app.slideInContainer.slider) {
        svs.app.slideInContainer.slider.destroy();
      }

      var containerElement = document.createElement('div'); 
      containerElement.id = 'slide-in-container';
      if (
        options.headerOptions.title === 'Statistik' &&
        !svs.core.detect.formfactor.mobile()
      ) {
        containerElement.className = 'statistic';
      }
      document.body.appendChild(containerElement);

      view = new svs.app.slide_in_container.views.SlideInContainer({
        model: new Backbone.Model(options)
      });
      view.render();

      if (options.showTabToggle) {
        var $tabToggle = $('.js-tab-toggle');
        var hammerElement = new window.Hammer($tabToggle.get(0));

        $tabToggle.data('offset-from', $tabToggle.css('top'));

        hammerElement
          .get('pan')
          .set({ direction: window.Hammer.DIRECTION_VERTICAL });
        hammerElement.on('panup pandown panend pancancel', function(e) {
          if (e.type === 'panend' || e.type === 'pancancel') {
            $tabToggle.data('offset-from', parseInt($tabToggle.css('top'), 10));
          } else if (e.type === 'panup' || e.type === 'pandown') {
            var newTop = $tabToggle.data('offset-from') + e.deltaY;
            if (!(parseInt($tabToggle.css('top'), 10) > 45 && newTop > 45)) {
              newTop = $tabToggle.css('top');
            }
            if (newTop < 0) {
              newTop = 0;
            }
            if (newTop > $(window).height() - $tabToggle.outerHeight()) {
              newTop = $(window).height() - $tabToggle.outerHeight();
            }
            $tabToggle.css('top', newTop + 'px');
          }
        });
      }
      svs.app.slideInContainer.slider = view;
    };

    return {
      init: init,
      toggle: function() {
        svs.app.slideInContainer.slider.toggleOpenClose();
      },
      open: function() {
        svs.app.slideInContainer.slider.toggleOpenClose(true);
      },
      close: function() {
        svs.app.slideInContainer.slider.toggleOpenClose(false);
      },
      destroy: function() {
        if (svs.app.slideInContainer.slider) {
          svs.app.slideInContainer.channel().trigger('close');
          svs.app.slideInContainer.slider.destroy();
        }
      },
      channel: function() {
        return Backbone.Radio.channel('app/slide-in-container');
      },
      hideNotification: function() {
        svs.app.slideInContainer.slider.toggleNotification(true);
      },
      showNotification: function() {
        svs.app.slideInContainer.slider.toggleNotification(false);
      }
    };
  })();
})(svs);

 })(window);